import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { AnalysisListResponse } from '@/api/domains/analyses/types';
import { Stat } from '../../hooks/useDashboardStats';
import styles from './KpiSection.module.css';
import { DocumentListResponse } from '@/api/domains/documents';

interface KpiSectionProps {
  analysesData: AnalysisListResponse | undefined;
  documentsData: DocumentListResponse | undefined;
  analysesLoading: boolean;
  documentsLoading: boolean;
  dynamicStats: Stat[] | null;
}

export const KpiSection = ({
  analysesData,
  documentsData,
  analysesLoading,
  documentsLoading,
  dynamicStats
}: KpiSectionProps) => (
  <section className={styles.kpiSection}>
    <div className={styles.kpiGrid}>
      <Card className={styles.kpiCard}>
        <div className={styles.kpiCardContent}>
          <div className={styles.kpiLabel}>Compliance Rate</div>
          {analysesLoading ? (
            <Skeleton width="80px" height="2rem" />
          ) : (
            <>
              <div className={styles.kpiValue}>
                {dynamicStats ? dynamicStats[1].value : '0'}%
              </div>
              <div className={styles.kpiProgress}>
                <div
                  className={styles.kpiProgressBar}
                  style={{
                    width: dynamicStats
                      ? `${parseInt(dynamicStats[1].value || '0')}%`
                      : '0%'
                  }}
                ></div>
              </div>
            </>
          )}
        </div>
      </Card>

      <Card className={styles.kpiCard}>
        <div className={styles.kpiCardContent}>
          <div className={styles.kpiLabel}>High Priority</div>
          {analysesLoading ? (
            <Skeleton width="80px" height="2rem" />
          ) : (
            <>
              <div className={styles.kpiValue} style={{ color: '#ff6b6b' }}>
                {analysesData
                  ? analysesData.analyses.reduce((sum, analysis) => {
                      return sum + Math.ceil(analysis.findings_count * 0.2);
                    }, 0)
                  : 0}
              </div>
              <div className={styles.kpiSubtext}>Require attention</div>
            </>
          )}
        </div>
      </Card>

      <Card className={styles.kpiCard}>
        <div className={styles.kpiCardContent}>
          <div className={styles.kpiLabel}>Medium Priority</div>
          {analysesLoading ? (
            <Skeleton width="80px" height="2rem" />
          ) : (
            <>
              <div className={styles.kpiValue} style={{ color: '#f59e0b' }}>
                {analysesData
                  ? analysesData.analyses.reduce((sum, analysis) => {
                      return sum + Math.ceil(analysis.findings_count * 0.3);
                    }, 0)
                  : 0}
              </div>
              <div className={styles.kpiSubtext}>Review needed</div>
            </>
          )}
        </div>
      </Card>

      <Card className={styles.kpiCard}>
        <div className={styles.kpiCardContent}>
          <div className={styles.kpiLabel}>Documents</div>
          {documentsLoading ? (
            <Skeleton width="80px" height="2rem" />
          ) : (
            <>
              <div className={styles.kpiValue} style={{ color: '#14692a' }}>
                {documentsData?.documents.length || 0}
              </div>
              <div className={styles.kpiSubtext}>In library</div>
            </>
          )}
        </div>
      </Card>
    </div>
    <p className={styles.kpiNote}>
      Note: These KPIs are for demonstration purposes only and do not reflect
      real data.
    </p>
  </section>
);
